"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondSectionWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SecondSectionWrap = styled_components_1.default.section `
  gap: 8px;

  .landing-second-section-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;

    .landing-second-section-row {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: center;
      justify-content: center;

      .landing-second-section-articulation {
        .landing-feature-title {
          width: 146px;
        }
      }
      .landing-second-section-sounds {
        .landing-feature-title {
          width: 197px;
        }
      }
      .landing-second-section-motor {
        .landing-feature-title {
          width: 169px;
        }
      }
      .landing-second-section-speech {
        .landing-feature-title {
          width: 75px;
        }
      }
      .landing-second-section-plan {
        .landing-feature-title {
          width: 187px;
        }
      }
      .landing-second-section-monitor {
        width: 205px;

        .landing-feature-title {
          width: 101px;
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    gap: 6px;

    .landing-second-section-content {
      gap: 16px;

      .landing-second-section-row {
        flex-direction: row;
        gap: 16px;

        .landing-second-section-articulation {
          .landing-feature-title {
            width: 218px;
          }
        }
        .landing-second-section-sounds {
          .landing-feature-title {
            width: 208px;
          }
        }
        .landing-second-section-motor {
          .landing-feature-title {
            width: 254px;
          }
        }
        .landing-second-section-speech {
          .landing-feature-title {
            width: 113px;
          }
        }
        .landing-second-section-plan {
          .landing-feature-title {
            width: 223px;
          }
        }
        .landing-second-section-monitor {
          width: 282px;

          .landing-feature-title {
            width: 160px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1000px) {
    .landing-second-section-row {
      .landing-second-section-articulation {
        .landing-feature-title {
          width: 218px;
        }
      }
      .landing-second-section-sounds {
        .landing-feature-title {
          width: 207px;
        }
      }
      .landing-second-section-motor {
        .landing-feature-title {
          width: 254px;
        }
      }
      .landing-second-section-speech {
        .landing-feature-title {
          width: 113px;
        }
      }
      .landing-second-section-plan {
        .landing-feature-title {
          width: 343px;
        }
      }
      .landing-second-section-monitor {
        width: 273px;

        .landing-feature-title {
          width: 151px;
        }
      }
    }
  }

  @media screen and (min-width: 1300px) {
    gap: 24px;

    .landing-second-section-content {
      gap: 15px;

      .landing-second-section-row {
        gap: 30px;

        .landing-second-section-articulation {
          .landing-feature-title {
            width: 245px;
          }
        }
        .landing-second-section-sounds {
          .landing-feature-title {
            width: 332px;
          }
        }
        .landing-second-section-motor {
          .landing-feature-title {
            width: 285px;
          }
        }
        .landing-second-section-speech {
          .landing-feature-title {
            width: 190px;
          }
        }
        .landing-second-section-plan {
          .landing-feature-title {
            width: 424px;
          }
        }
        .landing-second-section-monitor {
          width: 383px;

          .landing-feature-title {
            width: 173px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1690px) {
    .landing-second-section-content {
      gap: 30px;

      .landing-second-section-row {
        gap: 60px;

        .landing-second-section-articulation {
          .landing-feature-title {
            width: 327px;
          }
        }
        .landing-second-section-sounds {
          .landing-feature-title {
            width: 443px;
          }
        }
        .landing-second-section-motor {
          .landing-feature-title {
            width: 382px;
          }
        }
        .landing-second-section-speech {
          .landing-feature-title {
            width: 198px;
          }
        }
        .landing-second-section-plan {
          .landing-feature-title {
            width: 514px;
          }
        }
        .landing-second-section-monitor {
          width: 460px;

          .landing-feature-title {
            width: 230px;
          }
        }
      }
    }
  }

  @media screen and (min-width: 1920px) {
    .landing-second-section-content {
      display: flex;
      flex-direction: column;
      gap: 30px;
      align-items: center;
      justify-content: center;

      .landing-second-section-row {
        display: flex;
        gap: 60px;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;
